import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_FIELD__ALLOW_SIGNATURE_TYPES_SELECT,
  CONTRACT_SETUP_FIELD__CREATION_CANCEL,
  CONTRACT_SETUP_FIELD_TARGET_CHANGE,
  CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE,
} from '@app/store/actionTypes';
import AllowSignatureTypes from '@app/store/AllowSignatureTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import FieldType from '@app/store/FieldType';

export type ContractSetupTarget =
  | {
      participantId: string;
      type: FieldType.CHECKBOX_GROUP | FieldType.TEXT_FIELD;
    }
  | {
      allowSignatureTypes: AllowSignatureTypes;
      participantId: string;
      type: FieldType.SIGNATURE_FIELD;
    };

export type ContractSetupTargetState = ContractSetupTarget | null;

const initialState: ContractSetupTargetState = null;

export default function reducer(
  state: ContractSetupTargetState = initialState,
  action: ContractSetupAction
): ContractSetupTargetState {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP_FIELD__CREATION_CANCEL:
    case CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE:
      return initialState;
    case CONTRACT_SETUP_FIELD_TARGET_CHANGE:
      return action.payload;
    case CONTRACT_SETUP_FIELD__ALLOW_SIGNATURE_TYPES_SELECT: {
      if (state?.type === FieldType.SIGNATURE_FIELD) {
        return {
          ...state,
          allowSignatureTypes: action.payload.allowSignatureTypes,
        };
      }
      return state;
    }
    default:
      return state;
  }
}
